import React, { useEffect } from "react";
import { getAside3VizComponent } from "../../../../middleware/getVizDetails";
// import { registerLicense } from "@syncfusion/ej2-base";

// const key =
//   "Ngo9BigBOggjHTQxAR8/V1NBaF5cXmZCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdnWXtcdnRQQmFdVUV2W0o=";
// registerLicense(key);

const ChartsComp = (props) => {
  const {
    data,
    Sheetid,
    rowKeys,
    groupByKeys,
    valueKeys,
    vizType,
    isSheetInDashboard,
    toolTipKeys,
    sortProperties,
    isAnimataionOff,
    dataSourceID,
    filters,
    commonFilters,
    widthHeightObject,
    rowLimit,
    offset
  } = props;

  console.log(vizType);

  console.log(data, groupByKeys);

  useEffect(() => {
    console.log("data has changed");
    console.log(data);
  }, [data]);

  const RenderComp = getAside3VizComponent(vizType);
  if (!data) return null;
  if (data?.length === 0) return <p>No Data</p>;

  return (
    <>
      {RenderComp ? (
        <RenderComp
          Data={data}
          rowKeys={rowKeys}
          groupByKeys={groupByKeys}
          valueKeys={valueKeys}
          Sheetid={Sheetid}
          toolTipKeys={toolTipKeys}
          vizType={vizType}
          isSheetInDashboard={isSheetInDashboard}
          sortProperties={sortProperties}
          isAnimataionOff={isAnimataionOff}
          dataSourceID={dataSourceID}
          filters={filters}
          commonFilters={commonFilters}
          widthHeightObject={widthHeightObject}
          rowLimit={rowLimit}
          offset={offset}
        />
      ) : (
        <p>Select a component</p>
      )}
    </>
  );
};

// Custom equality check function
const areEqual = (prevProps, nextProps) => {
  // Compare data and vizType, memoize only when these change
  return (
    prevProps.data === nextProps.data &&
    prevProps.vizType === nextProps.vizType &&
    prevProps.Sheetid === nextProps.Sheetid
  );
};

// Export memoized component
export default React.memo(ChartsComp, areEqual);
